import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { FormV2FormSignature } from './form-v2-form-signature'

export class FormV2FormSignaturesRepository extends BaseRepository<FormV2FormSignature> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/forms-v2/form-signatures', token, cache)
    }

    // Query key é "t", não "token": "token" já é o parâmetro usado em toda a API para o JWT da sessão
    // logada, e colidia com este quando o link era aberto autenticado.
    async publicGetOne(formV2FormSignatureId: string, token: string) {
        const { json, statusCode, message } = await this.request.get(this.url + '/public/' + formV2FormSignatureId + '?t=' + token)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async publicSign(formV2FormSignatureId: string, token: string, dto: { document: string; geolocation: any }) {
        const { json, statusCode, message } = await this.request.post(
            this.url + '/public/' + formV2FormSignatureId + '/sign?t=' + token,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async resendEmail(formV2FormSignatureId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.url + '/' + formV2FormSignatureId + '/resend-email?token=' + this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
